.root {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 0.35rem;
    min-width: 0;
    line-height: 1;
}

.logo {
    display: block;
    width: 100%;
    max-width: 168px;
    height: auto;
}

.product {
    font-family: var(--mantine-font-family-monospace);
    font-weight: 700;
    font-size: 0.6875rem;
    letter-spacing: 0.0875em;
    text-transform: uppercase;
    color: var(--mt-brand-highlight);
}

.root[data-size='sm'] {
    flex-direction: row;
    align-items: center;
    gap: 0.6rem;
}

.root[data-size='sm'] .logo {
    width: auto;
    height: 28px;
    max-width: none;
}
